import { Popover as NextUIPopover, PopoverPlacement } from '@nextui-org/react';

import { ContentItem, PopoverContainer, StyledPopoverContent } from './CustomPopover.styles';

interface ItemProps {
  label: string;
  onClick?: () => void;
}

interface PopoverProps {
  isOpen: boolean;
  setIsOpen: (isOpen: boolean) => void;
  placement?: PopoverPlacement;
  trigger: React.ReactNode;
  items?: Array<ItemProps>;
}

const CustomPopover = ({ isOpen, setIsOpen, placement, trigger, items }: PopoverProps) => {
  return (
    <NextUIPopover isOpen={isOpen} onOpenChange={setIsOpen} placement={placement || 'bottom-right'}>
      <NextUIPopover.Trigger>{trigger}</NextUIPopover.Trigger>
      <StyledPopoverContent>
        <PopoverContainer>
          {items?.map((item) => {
            return (
              <ContentItem key={item.label} onClick={item.onClick}>
                <div>{item.label}</div>
              </ContentItem>
            );
          })}
        </PopoverContainer>
      </StyledPopoverContent>
    </NextUIPopover>
  );
};

export default CustomPopover;
